import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField.tsx';
import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import {
  selectForwardAccumulatorProperty,
  selectForwardAccumulatorValidation,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const LeverageRatio = () => {
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const leverage = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'leverage'));
  const validation = useAppSelector((state) => selectForwardAccumulatorValidation(state, tileId));

  const handleLeverage = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent('Forward Accumulator', 'Leverage ratio changed', value?.toString() ?? 'null');

    return check({
      leverage: isDefined(value) ? value : null,
    });
  };

  return (
    <FormField formattedMessageId="targetAccumulator.form.leverage">
      <TradeCaptureValidationWrapper validation={validation?.leverage}>
        <SgNumberInput
          valuePosition="start"
          selectAllOnFocus
          value={leverage}
          allowNegative={false}
          maxDecimals={9}
          onChange={handleLeverage}
          size="sm"
          data-e2e="leverage-ratio"
        />
      </TradeCaptureValidationWrapper>
    </FormField>
  );
};

export default LeverageRatio;
